import type {BillingPlan,BillingPlans} from '../src/billing-types';
import {formatCredits} from '../src/credit-units';
import {subscriptionPlanStorageBytes} from '../src/storage-policy';
import commerceCatalog from '../src/commerce-catalog.json';
import {Link} from './router';
import {billingCadence as cadence, billingMoney as money} from './lib/billing-format';
import {PAYMENT_METHODS} from '../src/payment-method-catalog';

const paymentProducts=commerceCatalog.products.filter(product=>product.id==='payments'||product.id==='crypto').map(product=>({
  ...product,
  methodGroups:(product.id==='crypto'?['crypto'] as const:['wallet','card'] as const).map(kind=>({kind,methods:PAYMENT_METHODS.filter(method=>method.kind===kind)})),
}));

export function SubscriptionPlanComparison({plans,selectedPlanId,destinationFor}:{
  plans:BillingPlans;
  selectedPlanId:string|null;
  destinationFor:(plan:BillingPlan)=>string;
}) {
  return <>
      {plans.plans.length === 0 ? <p>Subscriptions are not available yet.</p>
        : <div className="billing-plans">{plans.plans.map(plan => {
          const destination = destinationFor(plan);
          return <article className={`billing-plan${selectedPlanId===plan.id?' billing-plan-selected':''}`} data-plan={plan.key} key={plan.id} aria-labelledby={`plan-title-${plan.id}`}>
            <header className="subscription-plan-name">
              <div className="subscription-plan-title"><h2 id={`plan-title-${plan.id}`}>{plan.name}</h2>{plan.key==='max'&&<img className="subscription-plan-note" src="/assets/subscription-plans/great-for-building-games-136x44.png" alt="Great for building games!"/>}</div>
            </header>
            <p className="billing-price">{money(plan.unitAmount, plan.currency)} <span>/ {cadence(plan)}</span></p>
            <Link className="button subscription-plan-select" href={destination} aria-current={selectedPlanId===plan.id?'true':undefined}>Choose {plan.name}</Link>
            <div className="subscription-plan-credits">
              <p className="billing-allowance"><strong>{formatCredits(plan.periodCredits)}</strong> credits / {cadence(plan)}</p>
            </div>
            <div className="subscription-plan-inclusions">
              <h3>Included in {plan.name}</h3>
              <ul className="billing-features">
                <li>Your own computer (VM)</li>
                <li>Eight pre-configured agents</li>
                <li>{subscriptionPlanStorageBytes(plan.key) / 1_000_000_000} GB HD</li>
                <li>1 domain registration included</li>
                <li>One weekly reset.</li>
              </ul>
              <h3 className="subscription-plan-earn-title">Earn money with:</h3>
              <div className="subscription-plan-payment-products">{paymentProducts.filter(product=>plan.paymentProducts.some(id=>id===product.id)).map(product=><div className="subscription-plan-payment-product" key={product.id}>
                <h4 className="subscription-plan-product-name">{product.name}</h4>
                {product.methodGroups.map(group=><ul className="subscription-plan-payment-methods" key={group.kind} aria-label={group.kind==='wallet'?'Digital wallets':group.kind==='card'?'Card payments':'Crypto assets and networks'}>{group.methods.map(method=><li key={method.id}>{method.name}</li>)}</ul>)}
              </div>)}</div>
              {!plans.configuration.planActivationEnabled && plan.state !== "active" && <p className="billing-note">Payments coming soon. Account signup is available.</p>}
            </div>
          </article>;
        })}</div>}
      {plans.plans.length>0&&<div className="subscription-plan-notes"><p>Credit use depends on the work and the changes you request.</p><p>Payment processing fees apply when you accept payments from customers.</p></div>}
  </>;
}
